module.exports = __webpack_public_path__ + "img/CompetencyOverview.02a2f7a3.jpg";